// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"1e93f6ed","198":"03438e99","409":"5cbff11e","689":"4e35f0ea"}[chunkId] + ".chunk.js";
};